export default {
  lineTypes: [],
  hasAssignedSeatLine: false,
};
